import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';
import { OperationResult, TbAuthService } from '@tb/auth';
import { catchError } from 'rxjs/operators';
import { ServiceUtilsService } from './service-utils.service';
import { UrlMaker } from 'src/app/commons/url-maker';
import { EmailValidation } from 'src/app/model/EmailValidation';
import { ModelService } from './model.service';
import { WorkFlowService } from './work-flow.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';

@Injectable({
    providedIn: 'root',
})
export class MailService {
    storeApiUrl: string;

    // --------------------------------------------------------------------------------
    constructor(private http: HttpClient, private tbAuthService: TbAuthService, private modelService: ModelService, private workflow: WorkFlowService, private variable: TranslatedVariables,) {
        this.http = http;
        this.storeApiUrl = environment.settings.storeApiUrl;
    }

    // --------------------------------------------------------------------------------
    updateMail(mail: string, subscriptionKey: string): Observable<OperationResult> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        const urlMaker = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('validatedemail');

        const jobj : mailinfo  = {
            mailaddress : mail,
            subKey : subscriptionKey,
            validated : true
        };

        const bodyString = JSON.stringify(jobj);

        return this.http.post<OperationResult>(urlMaker.toString(), bodyString, { headers: headers });
    }

    public getEmailAddressByPaiWebSiteInfo(emailOrTag: string): Promise<OperationResult> {
        const urlMaker = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('mails');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            emailOrTag: emailOrTag,
            authToken: environment.auth.authToken,
        };

        return this.http.post<OperationResult>(urlMaker.toString(), JSON.stringify(jobj), { headers: headers }).toPromise();
    }

    saveEmail(subscriptionKey: string) {
        let emailEntity: EmailValidation;
        emailEntity = new EmailValidation();
        emailEntity.SubscriptionKey = subscriptionKey;
        if (this.tbAuthService.isSessionStorage()) {
            emailEntity.Email = sessionStorage.getItem('emailConfiguration');
            sessionStorage.removeItem('emailConfiguration');
        } else if (!this.tbAuthService.isSessionStorage()) {
            emailEntity.Email = localStorage.getItem('emailConfiguration');
            localStorage.removeItem('emailConfiguration');
        }
        if (emailEntity.Email) {
            this.modelService.saveMpEmail(emailEntity).subscribe(
                (emaiLSaveResult: { Result: any; Message: string }) => {
                    if (!emaiLSaveResult.Result) {
                        this.workflow.showMessage(this.variable.warningTitle, emaiLSaveResult.Message);
                    }
                },
                (err: { message: string }) => {
                    this.workflow.showMessage(this.variable.errorTitle, err.message);
                }
            );
        }
    }

    removeEmailConfiguration() {
        if (this.tbAuthService.isSessionStorage()) {
            sessionStorage.removeItem('emailConfiguration')
        } else if (!this.tbAuthService.isSessionStorage()) {
            localStorage.removeItem('emailConfiguration')
        }
    }
}

export class mailinfo {
    mailaddress: string;
    validated: Boolean;
    subKey: string;
}
